import { Button, Modal, Step, StepLabel, Stepper, TextField } from "@mui/material"
import CloseIcon from "@mui/icons-material/Close";
import { useContext, useState } from "react";
import { useLocation } from "react-router-dom";
import { AuthContext } from "../../AuthContext/AuthContext";
import { loader } from "../../Func_genericas/loader";
import { cores, mensagem_tem_a_certeza_de_apagar_alteracoes, operacao_erro, operacao_sucesso } from "../../Func_genericas/valores_estaticos";
import { del, post, put } from "../../Services/tokenConfig";
import { func_print } from "../../Func_genericas/func_print";
import { IChecklistItemSchema, IOperacaoAgricola } from "../../Interfaces/atividade/atividade";
import { CustomTextField } from "../../Styles/theme/customThemeprovider";
import { ITrabalhador } from "../../Interfaces/maoobra/maoobra";
import ConfirmDialog from "../../Components/CustomDialog/customdialog";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";

interface I_aux {
    list: IChecklistItemSchema[],
    flag_open_modal: boolean,
    set_flag_open_modal: React.Dispatch<React.SetStateAction<boolean>>,
    flag_open_modal_ver_mais: boolean,
    set_flag_open_modal_ver_mais: React.Dispatch<React.SetStateAction<boolean>>,
    flag_open_modal_edit: boolean,
    set_flag_open_modal_edit: React.Dispatch<React.SetStateAction<boolean>>,
    flag_open_modal_add: boolean,
    set_flag_open_modal_add: React.Dispatch<React.SetStateAction<boolean>>,
    setMessage: React.Dispatch<React.SetStateAction<string>>,
    setOpenSnackSuccess: React.Dispatch<React.SetStateAction<boolean>>,
    setOpenSnackError: React.Dispatch<React.SetStateAction<boolean>>,
    set_list: React.Dispatch<React.SetStateAction<IChecklistItemSchema[]>>,
    set_obj_new: React.Dispatch<React.SetStateAction<IChecklistItemSchema | undefined>>,
    obj_new: IChecklistItemSchema | undefined,
    obj_atividade: IOperacaoAgricola | undefined,
    lista_de_checklistes_aux: ITrabalhador[],
    set_obj_new_atividade: React.Dispatch<React.SetStateAction<IOperacaoAgricola | undefined>>,

}

export const Modaladdchecklists: React.FC<I_aux> = ({
    list,
    flag_open_modal,
    set_flag_open_modal,
    flag_open_modal_ver_mais,
    set_flag_open_modal_ver_mais,
    flag_open_modal_edit,
    set_flag_open_modal_edit,
    flag_open_modal_add,
    set_flag_open_modal_add,
    setMessage,
    setOpenSnackSuccess,
    setOpenSnackError,
    set_list,
    set_obj_new,
    obj_new,
    obj_atividade,
    lista_de_checklistes_aux,
    set_obj_new_atividade,

}) => {
    const auth = useContext(AuthContext);

    const [isLoading, setIsLoading] = useState<boolean>(false);

    const [flag_editado, set_flag_editado] = useState<boolean>(false);
    const [open_modal_tem_a_certeza_que_quer_apagar_alteracoes, set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes] = useState<boolean>(false);

    const [campo_obrigatorio_ordem, set_campo_obrigatorio_ordem] = useState<boolean>(false);
    const [open_modal_tem_a_certeza_que_quer_apagar_alteracoes_checklists, set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes_checklists] = useState<boolean>(false);

    const handler_add = async () => {

        try {
            setIsLoading(true);
            let res = await post(auth.token.cookie_token, 'api/operacoes/' + obj_atividade?.id_operacao + '/checklist/add', {
                payload: {
                    item: obj_new?.item === undefined ? '' : obj_new?.item,
                    ordem: obj_new?.ordem === undefined ? 0 : obj_new?.ordem?.toString().replace(',', '.')
                }
            });
            if (list === undefined || list.length === 0) {
                set_list([res.data.result])
                set_obj_new_atividade((old: any) => ({
                    ...old,
                    checklist: [res.data.result]
                }))
            } else {
                set_list((old: any) => [...old, res.data.result])
                set_obj_new_atividade((old: any) => ({
                    ...old,
                    checklist: [...(old?.checklist ?? []), res.data.result]
                }))

            }
            setMessage(operacao_sucesso)
            setOpenSnackSuccess(true);
            setIsLoading(false);
            func_reset_all()

        } catch (error) {
            func_print("handler_add", error, true);
            setMessage(operacao_erro)
            setOpenSnackError(true);
            setIsLoading(false);

        }

    }
    const handler_edit = async () => {

        try {
            setIsLoading(true);
            let res = await put(auth.token.cookie_token, 'api/operacoes/checklist/' + obj_new?.id_check, {
                payload: {
                    item: obj_new?.item === undefined ? '' : obj_new?.item,
                    ordem: obj_new?.ordem === undefined ? 0 : obj_new?.ordem?.toString().replace(',', '.'),
                    id_operacao: obj_new?.id_operacao === undefined ? 0 : obj_new?.id_operacao,
                    id_check: obj_new?.id_check === undefined ? 0 : obj_new?.id_check,
                    concluido: obj_new?.concluido === undefined ? false : obj_new?.concluido,
                }
            });

            let aux_list = list.map((el) => {
                if (el.id_check === obj_new?.id_check) {
                    return res.data.result
                } else {
                    return el
                }
            })

            set_list(aux_list)

            set_obj_new_atividade((old: any) => ({
                ...old,
                checklist: aux_list
            }))
            setMessage(operacao_sucesso)
            setOpenSnackSuccess(true);
            setIsLoading(false);
            func_reset_all()

        } catch (error) {
            func_print("handler_edit", error, true);
            setMessage(operacao_erro)
            setOpenSnackError(true);
            setIsLoading(false);
        }


    }

    const onInputChange = (e: any) => {
        const { name, value } = e.target;
        set_flag_editado(true)
        if (name === 'ordem') {
            if (!/^\d+$/.test(value)) {
                set_campo_obrigatorio_ordem(true)
            } else {
                set_campo_obrigatorio_ordem(false)
            }
            set_obj_new((prev: any) => ({
                ...prev,
                [name]: value,
            }));
        } else {
            set_obj_new((prev: any) => ({
                ...prev,
                [name]: value,
            }));
        }
    }


    const func_reset_all = () => {
        set_obj_new(undefined);
        set_flag_open_modal_edit(false);
        set_flag_open_modal(false);
        set_flag_open_modal(false);
        set_flag_editado(false)
        set_flag_open_modal_ver_mais(false);
        set_flag_open_modal_add(false);
        set_campo_obrigatorio_ordem(false);
    }
    const handleCloseDialog = () => {
        func_reset_all()
        set_flag_editado(false)
        set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)
    };
    const handle_delete_checklists = async () => {

        try {
            setIsLoading(true);
            await del(auth.token.cookie_token, `/api/operacoes/checklist/${obj_new?.id_check}`);
            list.splice(list.findIndex((checklist) => checklist.id_check === obj_new?.id_check), 1);
            set_obj_new(undefined);
            func_reset_all()
            set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes_checklists(false)
            setMessage(operacao_sucesso);
            setOpenSnackSuccess(true);
            setIsLoading(false);
        } catch (error) {
            func_print("handle_delete_checklists", error, true);
            setIsLoading(false);
            if ((error as any)?.response?.data?.message) {
                setMessage((error as any).response.data.message);
            } else {
                setMessage(operacao_erro);
            }
            setOpenSnackError(true);
        }
    };
    return (<Modal
        style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        }}
        open={flag_open_modal}
    >
        <div className="flex flex-col bg-white w-[70%] max-h-[80%] rounded-xl overflow-hidden">
            <div className="flex items-center justify-between w-full p-1 border-b border-gray-100">

                <div></div>


                <button
                    type="button"
                    onClick={() => {
                        if (flag_editado) {
                            set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                        } else {
                            set_flag_open_modal(false)
                            set_flag_open_modal_edit(false)
                            set_flag_open_modal_ver_mais(false)
                        }
                    }}
                    className="p-1 text-gray-400 hover:text-gray-600 transition-colors border-0 outline-none cursor-pointer !bg-transparent hover:!bg-transparent"
                >
                    <CloseIcon sx={{ fontSize: 24 }} />
                </button>
            </div>

            {
                isLoading === true ?
                    loader() :
                    <>
                        <div className="flex flex-col items-center w-full flex-1 overflow-auto">

                            <div className="flex items-center justify-between pl-5 w-full mb-4 pr-4">

                                <div className="grid grid-cols gap-2 ">

                                    <h2 className="text-xl font-semibold text-gray-800 m-0 pl-2">
                                        {
                                            flag_open_modal_edit === true ? 'Editar Checklist' :
                                                flag_open_modal_ver_mais === true ? 'Detalhes do Checklist' :
                                                    'Adicionar Checklist'
                                        }

                                    </h2>
                                </div>


                                {
                                    flag_open_modal_add === false && flag_open_modal_edit === false ?
                                        <div className="flex justify-between gap-2 mt-4">


                                            <button
                                                type="button"
                                                onClick={() => {
                                                    set_flag_open_modal(true);
                                                    set_flag_open_modal_edit(true);
                                                    set_flag_open_modal_add(false);
                                                    set_flag_open_modal_ver_mais(false);

                                                }}
                                                className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl font-medium text-sm text-white bg-[#c94f1e] hover:bg-[#b84720] transition-colors border-0 outline-none cursor-pointer"
                                            >
                                                <EditIcon sx={{ fontSize: 18 }} />
                                            </button>
                                            <button
                                                type="button"
                                                onClick={() => {
                                                    set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes_checklists(true)

                                                }}
                                                className="inline-flex items-center gap-2 px-4 py-2.5 rounded-xl font-medium text-sm text-white bg-[#c94f1e] hover:bg-[#b84720] transition-colors border-0 outline-none cursor-pointer"
                                            >
                                                <DeleteIcon sx={{ fontSize: 18 }} />
                                            </button>
                                        </div>
                                        : <></>
                                }
                            </div>


                            <div className="flex flex-col gap-6 w-full p-5 rounded-xl bg-gray-50/80">
                                {/* row 1: Designacao, Tipo, Localizacao, Stock minimo */}
                                <div className="flex flex-wrap gap-6 w-full">
                                    <div className="flex-1 min-w-[180px] flex flex-col gap-1">
                                        {
                                            flag_open_modal_ver_mais === true ? <>
                                                <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">Item</div>
                                                <div className="text-base font-medium text-gray-800">{obj_new?.item || '-'}</div>
                                            </>
                                                :
                                                flag_open_modal_edit === true ?
                                                    <div className="md:col-span-2 w-full">
                                                        <CustomTextField
                                                            variant="outlined"
                                                            label='Item'
                                                            name="item"
                                                            value={obj_new?.item === undefined ? '' : obj_new?.item}
                                                            onChange={onInputChange}
                                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                        />
                                                    </div> : <></>
                                        }
                                    </div>
                                    <div className="flex-1 min-w-[180px] flex flex-col gap-1">
                                        {
                                            flag_open_modal_ver_mais === true ? <>

                                                <div className="text-xs font-semibold uppercase tracking-wider text-gray-400">Ordem</div>
                                                <div className="text-base font-medium text-gray-800">{obj_new?.ordem || '-'}</div>
                                            </>
                                                :
                                                flag_open_modal_edit === true ?
                                                    <div className="md:col-span-2 w-full">
                                                        <CustomTextField
                                                            variant="outlined"
                                                            label='Ordem'
                                                            name="ordem"
                                                            value={obj_new?.ordem === undefined ? '' : obj_new?.ordem}
                                                            onChange={onInputChange}
                                                            error={campo_obrigatorio_ordem}
                                                            helperText={campo_obrigatorio_ordem ? 'Campo numérico' : ''}
                                                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
                                                        />
                                                    </div> : <></>
                                        }
                                    </div>

                                </div>


                            </div>
                            {flag_open_modal_ver_mais === true ? <></> :

                                <div className="p-5 flex justify-end w-full pt-4">


                                    <button
                                        type="button"
                                        onClick={() => {


                                            if (campo_obrigatorio_ordem === true) {
                                                setOpenSnackError(true);
                                                setMessage('Preencha os campos corretamente')

                                            } else {

                                                if (flag_open_modal_edit === true && flag_open_modal_add === false) {
                                                    handler_edit()
                                                } else if (flag_open_modal_add === true) {
                                                    handler_add()
                                                }
                                            }
                                        }}
                                        className="px-5 py-2.5 mt-4 rounded-xl font-medium text-sm text-white bg-[#c94f1e] hover:bg-[#b84720] transition-colors border-0 outline-none cursor-pointer"
                                    >
                                        Guardar Informação
                                    </button>
                                </div>
                            }


                        </div>


                    </>
            }
            <ConfirmDialog
                open={open_modal_tem_a_certeza_que_quer_apagar_alteracoes}
                onClose={() => set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)}
                onConfirm={() => handleCloseDialog()}
                message={mensagem_tem_a_certeza_de_apagar_alteracoes}
            />
            <ConfirmDialog
                open={open_modal_tem_a_certeza_que_quer_apagar_alteracoes_checklists}
                onClose={() => set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes_checklists(false)}
                onConfirm={() => handle_delete_checklists()}
                message={'Deseja eliminar o registo?'}

            />
        </div>



    </Modal >)

}
